import React from "react";

const RoomsForm = (props) => {
  const { address, setAddress, errorAnimation } = props;
  const handleChange = (event) => {
    const { value } = event.target;
    let roomsArray = [];
    for (let i = 1; i <= value; i++) {
      roomsArray.push({
        id: i,
        roomName: `room-${i}`,
        rent: null,
        securityDep: null,
        billsPercentage: null,
        roommateFirstName: "",
        roommateLastName: "",
        roommateEmail: "",
        images: [],
        occupied: false,
      });
    }
    setAddress((prevState) => ({ ...prevState, rooms: roomsArray }));
  };

  return (
    <>
      <div
        className={`flex justify-center text-center mt-5 px-10 ${errorAnimation.rooms}`}
      >
        How many rooms/spaces are available for rent at this property?
      </div>
      <form className="grid mt-5">
        <input
          id="rooms"
          name="rooms"
          type="tel"
          min={0}
          maxLength={3}
          value={address.rooms.length === 0 ? "" : address.rooms.length}
          onChange={handleChange}
          className={`w-20 border-gray-300 border-2 rounded-lg text-center p-2 ${errorAnimation.rooms}`}
        />
      </form>
      {errorAnimation.rooms && (
        <div
          className={`flex justify-center text-center mt-5 px-10 ${errorAnimation.rooms}`}
        >
          Max is 100!
        </div>
      )}
    </>
  );
};

export default RoomsForm;
